<template>
    <div>
        <vs-card>
            <div class="flex items-center justify-between" slot="header">
              <div class="inline-flex items-center">
                <vs-button type="border" @click="$router.go(-1)" icon="chevron_left"></vs-button>
                <h4 class="ml-2">{{projectDetails.name}}</h4>
              </div>
                <!-- <vs-button  @click="warningPopup">Complete Project</vs-button>  -->
            </div>
            <div>
                <p>{{projectDetails.details}}</p>
            </div>
            <div class="flex items-center my-4">
                <div v-if="projectDetails.userProjectMember.length !== 0 || projectDetails.clientProjectMember.length !== 0" class="flex justify-flex-end">
                    <div class="cstm-img-holder" v-for="(pic,index2) in projectDetails.clientProjectMember.concat(projectDetails.userProjectMember)" :key="index2">
                       <vs-tooltip v-if="pic.picture !== ''" :text="pic.first_name+' '+pic.last_name">
                                <img :src="pic.picture" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                              </vs-tooltip>
                              <vs-tooltip v-else :text="pic.first_name+' '+pic.last_name">
                                <img src="@/assets/images/pages/user-circle-solid.svg" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                              </vs-tooltip>
                    </div>
                </div>
                <div class="date_container">
                    <feather-icon icon="CalendarIcon" />
                    <label>Due Date</label>
                    <vs-input :value="projectDetails.due_date.split(' ')[0]" readonly/>
                </div>
            </div>
            <vs-divider />
            <div class="task-kanban-holder">
                <div :key="item.id" v-for="item in projectDetailsData" >
                    <h4 class="text-center">{{item.name}}</h4>
                    <draggable 
                group="id" 
                :list="item.tasks"
                :id="item.id"
               
               :move="checkMove"  class="w-full py-2 cursor-move">
               <div  :key="taskListing.id" v-for="taskListing in item.tasks">
                    <div class="card-holder" @click="showModalForEdit(taskListing)">
                        <div class="flex justify-between items-start">
                            <h6 class="mb-4">{{taskListing.name}}</h6>
                          
                        </div>
                        <p class="content mb-4">{{taskListing.details}}</p>
                        <div class="name-badge-holder">
                            <!-- <p class="name">{{userInfo.first_name}}</p> -->
                            <span class="cstm-badge" :class="['badge-' + taskListing.status.id]">
                          
                              {{taskListing.status.status}}
                            </span>
                        </div>
                        <div class="kanban-icon-holder">
                            <div>
                                <div class="mr-2">
                                    <feather-icon icon="ClockIcon" />
                                    <span>{{taskListing.due_date.split(' ')[0]}}</span>
                                </div>

                                <!-- <div class="mr-2">
                                    <feather-icon icon="LinkIcon" />
                                    <span>1</span>
                                </div> -->
                            </div>


                             <div v-if="taskListing.task_priority.id === 2" class="mediumPriority">
                            <feather-icon icon="ArrowUpIcon" />
                        </div>
                        <div v-if="taskListing.task_priority.id === 1" class="highPriority">
                            <feather-icon icon="ArrowUpIcon" />
                        </div>
                        <div v-if="taskListing.task_priority.id === 3" >
                            <feather-icon color="success" icon="ArrowUpIcon" />
                        </div>
                        <div v-if="taskListing.task_priority.id === 4" >
                            <feather-icon color="success" icon="ArrowUpIcon" />
                        </div>
                      
                        </div>
                        <div v-if="taskListing.clientParticipant.length !== 0 || taskListing.userParticipant.length !== 0" class="flex justify-flex-end">
                            <div class="cstm-img-holder" v-for="(pic,index2) in taskListing.clientParticipant.concat(taskListing.userParticipant)" :key="index2">
                                <vs-tooltip v-if="pic.picture !== ''" :text="pic.first_name+' '+pic.last_name">
                                <img :src="pic.picture" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                              </vs-tooltip>
                              <vs-tooltip v-else :text="pic.first_name+' '+pic.last_name">
                                <img src="@/assets/images/pages/user-circle-solid.svg" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                              </vs-tooltip>
                            </div>
                        </div>
                    </div>
                </div>
                    </draggable>

                    
                </div>
            </div>
        </vs-card>
        <vs-popup title="Details" :active.sync="kanbanActive">
            <form class="flex flex-wrap">
                <div class="w-full">
                    <div class="name-badge-holder">
                        <span class="cstm-badge primary-badge">
                            {{taskData.projectStatusTag}}
                        </span>
                    </div>
                </div>
                <vs-row>
                  <vs-col vs-lg="12" vs-sm="12" vs-xs="12" class="px-2 mb-2">
                    <h5 class="mb-2">Status</h5>
                
                    <select v-model="taskData.task_status_id" @change="StatusChnage(taskData)" name="cars" id="cars" form="carform" class="w-100 selectExample mt-2 customSelect">
      <option :key="index" :value="item.id" :label="item.status" v-for="(item,index) in options" class="selectOptionclass"/>
    </select>
                 
                  </vs-col>
                  <vs-divider />
                  <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="px-2 mb-2">
                    <h5 class="mb-2">Task Name: </h5>
                    <p>{{taskData.name}}</p>
                  </vs-col>
                  <vs-col vs-lg="12" vs-sm="12" vs-xs="12" class="px-2 mb-2">
                    <h5 class="mb-2">Description</h5>
                    <p>{{taskData.details}}</p>
                  </vs-col>
              
                  <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="px-2 mb-2">
                    <h5 class="mb-2">Responsible Person</h5>
                    <span :key="index4" v-for="(person, index4) in responsibleData" >
                        {{person.first_name}} {{person.last_name}}
                        <span v-if="index4+1 < responsibleData.length">,</span>
                    </span>
                  </vs-col>
                 
                  <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="px-2 mb-2">
                    <h5 class="mb-2">Due Date</h5>
                    <p>{{taskData.due_date}}</p>
                  </vs-col>
                  <vs-tabs class="inner-tab tooltip_icon_tab" v-model="selectedTab">
                      <vs-tab label="Created By" icon-pack="feather" icon="icon-users">
                          <div class="my-2">
                              <div class="flex items-center">
                                  <feather-icon icon="UserIcon" />
                                  <span class="mx-1">Created By</span>
                              </div>
                              <div class="flex flex-wrap -mx-2">
                                  <div class="w-full px-2">
                                    <strong class="block my-2">{{userInfo.first_name}}</strong>
                                  </div>
                              </div>
                          </div>

                          <div class="my-2">
                              <div class="flex items-center">
                                  <feather-icon icon="UserIcon" />
                                  <span class="mx-1">Participants</span>
                              </div>
                              <div class="flex flex-wrap -mx-2">
                                  <div class="cstm-inp flex-wrap">
                                    <span class="cstm-badge flex items-center" :key="index4" v-for="(person, index4) in participantData">
                                                              {{person.first_name}} {{person.last_name}}
                                                          </span>                
                                  </div>
                              </div>
                          </div>

                          <div class="my-2">
                              <div class="flex items-center">
                                  <feather-icon icon="UserIcon" />
                                  <span class="mx-1">Observers</span>
                              </div>
                              <div class="flex flex-wrap -mx-2">
                                  <div class="cstm-inp flex-wrap">
                                      <span class="cstm-badge flex items-center" :key="index4" v-for="(person, index4) in observerData">
                                                              {{person.first_name}} {{person.last_name}}
                                                          </span>
                                  </div>
                              </div>
                          </div>
                      </vs-tab>
                      <vs-tab label="Time Planning" icon-pack="feather" icon="icon-clock">
                          <div>
                                                  <div class="flex items-center my-2">
                                                      <feather-icon icon="ClockIcon" />
                                                      <span class="mx-1">Time Planning</span>
                                                  </div>
                                                  <label>From:</label>&nbsp;&nbsp;{{taskData.from_time}}<br>
                                                  <label>To:</label>&nbsp;&nbsp;{{taskData.to_time}}
                                                  <vs-divider />
                                                  <div>
                                                <div class="flex items-center my-2">
                                                    <feather-icon icon="ClockIcon" />
                                                    <span class="mx-1">Log History</span>
                                                </div>
                                                    <div class="cstm-badge flex items-center" :key="index10" v-for="(log, index10) in logHistory">
                                                {{log.no_of_days}}
                                                <span class="mx-2">Days</span>
                                                {{log.no_of_hours}}
                                                <span class="mx-2">Hour</span>
                                            </div>
                                                </div>
                                              </div>
                      </vs-tab>

                      <vs-tab label="Assignment" icon-pack="feather" icon="icon-list">
                        <span v-if="taskData.checklist.length !== 0">
                                                <span :key="index8" v-for="(item1, index8) in taskData.checklist">
                                                  <div class="flex flex-wrap items-center">
                                                  <div class="flex items-center my-2 lg:w-1/5 w-full">
                                                        <span class="material-icons">assignment</span>
                                                        <span class="mx-2">{{item1.name}}</span>
                                                  </div>
                                                      <vs-progress class="lg:w-1/2 md:w-3/5" :percent="(item1.itemStatusCal.length/item1.todos.length)*100" color="primary"></vs-progress>
                                                      <div class="progress-status">
                                                          Completed: {{item1.itemStatusCal.length}} out of {{item1.todos.length}}
                                                      </div>
                                                  </div>
                                                      <ul class="task-checklist mb-4" >
                                                      <li class="flex justify-between"  :key="index9" v-for="(item2, index9) in item1.todos">
                                                        {{item2.todo}}
                                                      </li> 
                                                      </ul>
                                                </span>  
                                            </span>
                      </vs-tab>

                      <vs-tab label="Project" icon-pack="feather" icon="icon-grid">
                          <div>
                              <div class="flex flex-wrap items-center">
                                  <label class="w-1/5">Project</label>
                                  <div class="cstm-inp w-1/2">
                                               <span v-if="showDataForProject"> {{showDataForProject.name}}</span>
                                                </div>
                              </div>
                              <vs-divider />

                              <div class="flex flex-wrap items-center">
                                  <label class="w-1/5">Remind about task</label>
                                  <div class="inline-flex items-center m-1" :key="index" v-for="(item, index) in reminderTime">
                                                            {{item.reminder_time}}<br />
                                                        </div>
                              </div>
                              <vs-divider />

                              <div class="flex flex-wrap items-center">
                                  <label class="w-1/5">Gantt</label>
                              </div>
                              <vs-divider />

                              <div class="flex flex-wrap items-center">
                                  <label class="w-1/5">CRM</label>
                                   <span class="cstm-badge flex items-center" :key="index8" v-for="(crm, index8) in selectedCRMData">
                                                        <span v-if="crm.lead_first_name != ''">{{crm.lead_first_name}}</span><span v-if="crm.lead_middle_name != ''">&nbsp;{{crm.lead_middle_name}}</span><span v-if="crm.lead_last_name != ''">&nbsp;{{crm.lead_last_name}}</span>
                                                    </span>
                              </div>
                              <vs-divider />

                              <div class="flex flex-wrap items-center">
                                  <label class="w-1/5">SubTask</label>
                                  <span class="cstm-badge flex items-center" :key="index8" v-for="(task, index8) in selectedSubTaskData">
                                                        {{task.name}}
                                                    </span>
                              </div>
                              <vs-divider />

                              <div class="flex flex-wrap items-center">
                                  <label class="w-1/5">Tags</label>
                                   <v-select
                                                            class="w-full"
                                                            label="name"
                                                            taggable
                                                            :reduce="(option) => option.id"
                                                            :create-option="
                                                            (option) => ({ id: option, label: option, name: option })
                                                            "
                                                            :options="tagsList"
                                                            v-model="taskData.tags"
                                                            :clearable="false"
                                                            data-vv-name="name"
                                                            name="name"
                                                            multiple
                                                            :disabled= "true"
                                                        >
                                                        </v-select>
                              </div>
                              <vs-divider />
                          </div>
                      </vs-tab>
                      <vs-tab label="Editor" icon-pack="feather" icon="icon-type">
                        <div class="flex items-center">
                          <p v-html="taskData.comments"></p>
                        </div>
                      </vs-tab>
                  </vs-tabs>
                  <vs-divider />
                </vs-row>
            </form>
        </vs-popup> 
    
    </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { Project } from './mixins/project.js'
import { TaskProject } from './mixins/task-project.js'
import draggable from 'vuedraggable'
import vSelect from 'vue-select'
import {projectKanbanShow, taskUpdate } from '@/api/task-project.js'

export default {
  name: 'project-details',
  mixins: [Project, TaskProject],
  components: {
    flatPickr,
    draggable,
    vSelect
  },
  data () {
    return {
      options: [
        {id: 1, status: 'To Do'},
        {id: 2, status: 'In Progress'},  
        {id: 3, status: 'Done'}
      ],
      warningPopupShow: false,
      warningPopupShow2: false,
      userInfo: JSON.parse(localStorage.getItem('Clientuser')),
      projectDetails: {
        platform_project_completion_status: {
          id: ''
        },
        name: '',
        userProjectMember: [],
        clientProjectMember: [],
        due_date: '',
        details: ''
      },
      todo: [],
      inProgress: [],
      statusData: [],
      todoTab: true,
      progressTab: false
    }
  },
  created () {
    this.getAllTask()
  },
  // mounted () {
  //   this.getAllTask()
  // },
  methods: {
    warningPopup () {
      this.warningPopupShow = true
    },

    getAllTask () {
      this.$vs.loading({type: 'radius'})
      projectKanbanShow(this.$route.params.id)
        .then((res) => {
          console.log(res.data.data)
          this.projectDetailsData = res.data.data.project_status
          this.projectDetails.platform_project_completion_status.id = res.data.data.project.platform_project_completion_status.id
          this.projectDetails.name = res.data.data.project.name
          this.projectDetails.details = res.data.data.project.details
          this.projectDetails.userProjectMember = res.data.data.project.userProjectMember
          this.projectDetails.clientProjectMember = res.data.data.project.clientProjectMember
          this.projectDetails.due_date = res.data.data.project.due_date
          this.$vs.loading.close()
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
        })
    },
    checkMove (evt) {
      const id = evt.draggedContext.element.id
      const changestatusTo = evt.to.id
      const payload = {
        updateField: {
          project_status_id: changestatusTo
        }
      }
      if (evt.from.id !== evt.to.id) {
        this.kanbanStatusUpdate(id, payload)
      }
    },
    async kanbanStatusUpdate (id, payload) {
      this.$vs.loading({type: 'radius'})
      try {
        await taskUpdate(id, payload)
        this.getAllTask()
        this.$vs.loading.close()
        this.$vs.notify({
          title: 'Success',
          text: 'Task status changed',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch (apiError) {
        console.log(apiError)
        this.$vs.loading.close()
      }
    },
    tabView (type) {
      if (type === 'todo') {
        this.todoTab = true
        this.progressTab = false
      } else if (type === 'progress') {
        this.todoTab = false
        this.progressTab = true
      }
    }
  
  }
}
</script>
<style scoped>
  .customSelect {
    border-radius:3px;
    border: 1px solid #CCCCCC;
    width: 100%;
    height:30px;
    background-color: white;
    color:#757575
    /* font-family: $font-family-base'; */
  }
  .selectOptionclass :hover
  {
    background-color:yellow;
    color:white;
    border:none;
  }
</style>